import * as React from "react";

export const SectionContainer = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
        }}
    >
        {children}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/householdInsurance/components/HouseholdInsuranceSectionContainer.tsx